// extracted by mini-css-extract-plugin
export default {"clear":"reset_clear_do-sB","clearfix":"reset_clearfix_2lj2w"};